<template>
  <div>
    <div class="survey-module-right-action">
        <div class="table-controls justify-between">
            <div class="table-controls-btn align-center">
              <!-- <div class="table-controls-btn-item btn-color1" @click="handleOpen()">新增</div> -->
              <div class="table-controls-btn-item btn-color2" @click="dialogVisible = true">导入</div>
              <div class="table-controls-btn-item btn-color3" @click="exportFun()">导出</div>
            </div>
            <div class="table-controls-btn align-center">
              <input type="text" v-model="queryParams.name" placeholder="请输入考生姓名" autocomplete="off">
              <div class="table-controls-btn-item btn-color3" @click="handleQuery()">搜索</div>
              <div class="table-controls-btn-item btn-color4" @click="resetQuery()">重置</div>
            </div>
          </div>
          <div class="table-body">
            <el-table
              v-loading="loading"
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="{background:'#72b701',color:'#fff'}"
            >
              <el-table-column prop="name" label="姓名" align="center" :show-overflow-tooltip="true"/>
              <!-- <el-table-column prop="identityCard" label="身份证号" align="center" :show-overflow-tooltip="true"/> -->
              <el-table-column prop="sex" label="性别" align="center" :show-overflow-tooltip="true"/>
              <el-table-column prop="admissionTicket" label="准考证号" align="center" :show-overflow-tooltip="true"/>
              <el-table-column prop="theoreticalScore" label="理论分数" align="center" :show-overflow-tooltip="true"/>
              <el-table-column prop="skillScore" label="实操分数" align="center" :show-overflow-tooltip="true"/>
              <el-table-column prop="createTime" label="创建时间" align="center" :show-overflow-tooltip="true"/>
              <el-table-column
                fixed="right"
                label="操作"
                align="center" width="120" >
                <template slot-scope="scope">
                  <el-button @click="handleOpen(scope.row)" type="text" size="small">查看</el-button>
                  <el-button type="text" size="small" @click="deleteItemFun(scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-content justify-end">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="queryParams.pageNum"
                :page-size="queryParams.pageSize"
                background
                layout="total,prev, pager, next, jumper"
                prev-text="上一页"
                next-text="下一页"
                :total="total">
              </el-pagination>
          </div>
      </div>
      <el-dialog
        :title="dialog.title"
        :visible.sync="dialog.visible"
        width="40%"
        :before-close="closeDialog"
        >
        <div class="login-form-box">
          <el-form :model="referForm" :rules="referRules" ref="referForm" label-position='right'>
            <el-form-item label="姓名：">
              <span>{{ referForm.name }}</span>
            </el-form-item>
            <el-form-item label="身份证号：">
              <span>{{ referForm.identityCard }}</span>
            </el-form-item>
            <el-form-item label="性别：">
              <span>{{ referForm.sex }}</span>
            </el-form-item>
            <el-form-item label="出生日期：">
              <span>{{ referForm.birthday }}</span>
            </el-form-item>
            <el-form-item label="民族：">
              <span>{{ referForm.nation }}</span>
            </el-form-item>
            <el-form-item label="学历：">
              <span>{{ referForm.qualification }}</span>
            </el-form-item>
            <el-form-item label="准考证号：">
              <span>{{ referForm.admissionTicket }}</span>
            </el-form-item>
            <el-form-item label="理论分数：">
              <span>{{ referForm.theoreticalScore }}</span>
            </el-form-item>
            <el-form-item label="实操分数：">
              <span>{{ referForm.skillScore }}</span>
            </el-form-item>
            <el-form-item label="考次：">
              <span>{{ referForm.examFrequency }}</span>
            </el-form-item>
            <el-form-item label="手机号：">
              <span>{{ referForm.phone }}</span>
            </el-form-item>
            <el-form-item label="地址：">
              <span>{{ referForm.address }}</span>
            </el-form-item>
            <el-form-item label="详细地址：">
              <span>{{ referForm.fullAddress }}</span>
            </el-form-item>
            <el-form-item label="户籍所在地：">
              <span>{{ referForm.registeredResidence }}</span>
            </el-form-item>
          </el-form>
         </div>
      </el-dialog>
      <!-- 导入弹窗 -->
      <el-dialog
        title="导入考生"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <div style="display: flex;justify-content: center;">
          <el-upload
          class="upload-demo"
          drag
          :headers="headers"
          :action="$baseUrl +'/api/file/upload'"
          :on-success="handleSuccess"
          multiple>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="daoruFun()">开始导入</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import { getList, addItem, editItem, delItem,uploadScore } from "@/api/ksgl_ks";
export default {
  props:['examId'],
  data(){
    return{
      headers:{
        "token":localStorage.getItem("foregroundToken")
      },
      loading:false,
      queryParams:{
        pageNum: 1,
        pageSize: 10,
        name: "",
      },
      total:0,
      tableData: [],
      dialog:{
        title:'',
        visible:false
      },
      referForm: {
        id: undefined,
        // 照片
        url:'',
        // 姓名
        name:'',
        // 身份证号
        identityCard:'',
        // 性别
        sex:'',
        // 出生日期
        birthday:'',
        // 民族
        nation:'',
        // 学历
        qualification:'',
        // 政治面貌
        politicalOutlook:'',
        // 手机号
        phone:'',
        // 地址
        address:'',
        // 详细地址
        fullAddress:'',
        // 户籍所在地
        registeredResidence:'',
        // 科目：0理论加实操，1理论，2实操
        subject:'',
        // 心理咨询师级别  2二级 3三级 4四级
        level:'',
        // 具备条件(传值待定)
        qualified:'',
        // 从业年限  几年就是几,十年以上传more
        life:'',
        // 考次
        examFrequency:'',
        // 审核状态    '未审核','未通过','已通过'
        auditStatus:'',
        theoreticalScore:'',
        skillScore:'',
        resultsSime:'',
        admissionTicket:'',
      },
      referRules: {
        url: [{ required: true, message: "请上传照片", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        identityCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            pattern:
              /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: "证件号码格式有误！",
            trigger: "blur",
          },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        birthday: [{ required: true, message: "请选择出生日期", trigger: "blur" }],
        nation: [{ required: true, message: "请输入民族", trigger: "blur" }],
        qualification: [{ required: true, message: "请输入学历", trigger: "blur" }],
        politicalOutlook: [{ required: true, message: "请输入政治面貌", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        fullAddress: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        registeredResidence: [{ required: true, message: "请输入户籍所在地", trigger: "blur" }],
        subject: [{ required: true, message: "请选择科目", trigger: "blur" }],
        level: [{ required: true, message: "请选择心理咨询师级别", trigger: "blur" }],
        qualified: [{ required: true, message: "请输入具备条件", trigger: "blur" }],
        life: [{ required: true, message: "请选择从业年限", trigger: "blur" }],
        examFrequency: [{ required: true, message: "请输入考次", trigger: "blur" }],
        auditStatus: [{ required: true, message: "请选择审核状态", trigger: "blur" }],
      },

      // 导入
      dialogVisible: false,
      fileList:[]
    }
  },
  created(){
      this.handleQuery()
  },
  methods:{
    handleOpen(row){
      if(row){
        for(let key in this.referForm){
          this.referForm[key] = row[key]
        }
      }
      this.dialog.title = row?'编辑考生':'新增考生'
      this.dialog.visible = true
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val
      this.handleQuery()
    },
 
    /** 查询 */
    handleQuery() {
      this.loading = true;
      getList({
         examId:this.examId,
        ...this.queryParams
        })
        .then(({ data }) => {
          this.tableData = data.list;
          this.total = data.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /** 角色保存提交 */
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          const roleId = this.referForm.id;
          if (roleId) {
            editItem(roleId, {
              examId:this.examId,
              ...this.referForm
            })
              .then((res) => {
                this.$message({type: 'success', message: res.message});
                this.closeDialog();
                this.resetQuery();
              })
              .finally(() => {
                this.loading = false
              });
          } else {
            addItem({
              examId:this.examId,
              ...this.referForm
            } )
              .then((res) => {
                this.$message({type: 'success', message: res.message});
                this.closeDialog();
                this.resetQuery();
              })
              .finally(() => {
                this.loading = false
              });
          }
        }
      });
    },
    /** 关闭表单弹窗 */
    closeDialog() {
      this.dialog.visible = false;
      this.resetForm();
    },
    /** 重置表单 */
    resetForm() {
      this.referForm.id = undefined;
      for(let key in this.referForm){
        this.referForm[key] = ''
      }
      this.queryParams.pageNum = 1
      this.handleQuery()
    },
    /** 重置查询 */
    resetQuery() {
      this.queryParams.pageNum = 1;
      this.queryParams.name = ''
      this.handleQuery();
    },
    deleteItemFun(id){ 
      this.$confirm('此操作将永久删除此会员, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delItem([id]).then((res)=>{
            this.handleQuery()
            this.$message({
              type: 'success',
              message: res.message
            });
          })
         
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    // 上传-start
    handleAvatarSuccess(res, file) {
      this.referForm.url = res.data.filePath
    },
    handleAvatarError() {
      this.$confirm('当前页面已失效，请重新登录', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      const identity = localStorage.getItem("identity")
      this.$router.push({ path:'/loginPage',query:{tab:identity=='admin'?2:0}});
      localStorage.setItem("foregroundToken","")
      localStorage.setItem("identity","")
    })
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    // 上传-end

    // 导入
  
    handleSuccess(response, file,fileList){
      let arr = []
      for(let i=0;i<fileList.length;i++){
        arr.push(fileList[i].response.data.filePath)
      }
      this.fileList = arr
    },
    daoruFun(){
      uploadScore(this.fileList).then((res)=>{
        this.$message.success(res.message);
        this.handleClose()
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.fileList = []
    },
    // 导出
    exportFun(){
      fetch(`${this.$baseUrl}/api/examinee/exportScore`, {headers:this.headers })
        .then((response) => response.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "考生管理导出.xlsx";
          link.click();
        });
    }
  }
}
</script>
<style scoped lang="css" src="../../views/ksgl-page/assets/css/rem.css" />
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>